import React from 'react'
import styled from '@emotion/styled'
import { bool, object, string } from 'prop-types'

import { AuthorInfo } from '@jelly/components'

// Styled Components via Emotion
export const ArticleCard = styled.div`
	height: 100%;
	width: 100%;
	a {
		color: ${({ theme }) => theme.hubTemplate.articleTitle};
	}

	&:hover {
		a {
			color: ${({ theme }) => theme.hubTemplate.articleTitleHover};
		}
	}
`
const ArticleTitle = styled.div`
	font-size: 20px;
	padding-bottom: 5px;

	${({ theme }) => theme.MQ.M} {
		font-size: 21px;
	}

	@media (min-width: 1025px) and (max-width: 1200px) {
		font-size: 18px;
	}
`

EvergreenArticleCard.propTypes = {
	author: object,
	canonical: string.isRequired,
	sponsor: object,
	sponsored: bool,
	title: string.isRequired,
}

export function EvergreenArticleCard({ author, canonical, isSponsored, sponsor, sponsorship, title }) {
	return (
		<ArticleCard>
			<a alt={title} href={canonical}>
				<ArticleTitle>{title}</ArticleTitle>
				<AuthorInfo
					author={author}
					sponsor={isSponsored && sponsorship.sponsorType === 'single-sponsor' ? sponsorship : sponsor}
					isSponsored={isSponsored}
				/>
			</a>
		</ArticleCard>
	)
}
